import {
	type FindAuthenticationOptionsResponse,
	type FindRegistrationOptionsResponse,
	type Passkey,
	PasskeyDeviceTypesOptions,
	type PasskeyRepository,
	type TokenPair
} from '@contexts/auth/domain';
import { generateTokenPair } from '@contexts/auth/infrastructure/in-memory/in-memory-auth.repository';
import {
	uuidValueObject,
	type WebAuthnAuthenticationAssertion,
	type WebAuthnRegistrationCredential
} from '@contexts/shared/domain';

const passkeys: Passkey[] = [generateValidPasskeys()];

export function inMemoryPasskeyRepositoryBuilder(): PasskeyRepository {
	return {
		async findRegistrationOptions(): Promise<FindRegistrationOptionsResponse> {
			const mockWebAuthnRegistrationInput: FindRegistrationOptionsResponse = {
				options: {
					rp: {
						name: 'Demo App',
						id: 'localhost'
					},
					user: {
						id: 'dXNlcjEyMw',
						name: 'user@example.com',
						displayName: 'Demo User'
					},
					challenge: 'Y2hhbGxlbmdlMTIzNDU',
					pubKeyCredParams: [
						{ type: 'public-key', alg: -7 },
						{ type: 'public-key', alg: -257 }
					],
					timeout: 60000,
					attestation: 'none',
					authenticatorSelection: {
						residentKey: 'preferred',
						userVerification: 'preferred'
					},
					excludeCredentials: []
				},
				token: 'token'
			};

			return mockWebAuthnRegistrationInput;
		},
		async register(
			_token: string,
			name: string,
			options: WebAuthnRegistrationCredential
		): Promise<void> {
			passkeys.push({
				id: '2',
				deviceType: PasskeyDeviceTypesOptions.MULTI_DEVICE,
				backedUp: false,
				transports: ['internal', 'usb'],
				name,
				createdAt: Date.now(),
				lastUsedAt: Date.now()
			});
			return void 0;
		},
		async findAuthenticationOptions(
			_token: string
		): Promise<FindAuthenticationOptionsResponse> {
			const mockWebAuthnAuthenticationInput: FindAuthenticationOptionsResponse = {
				options: {
					challenge: 'YXV0aENoYWxsZW5nZTEyMw',
					timeout: 60000,
					rpId: 'localhost',
					allowCredentials: [
						{
							id: 'Y3JlZGVudGlhbElEMTIz',
							type: 'public-key',
							transports: ['internal', 'usb']
						}
					],
					userVerification: 'preferred'
				},
				token: 'mock-challenge-token'
			};

			return mockWebAuthnAuthenticationInput;
		},
		async authenticate(
			_token: string,
			_rememberMe: boolean,
			assertion: WebAuthnAuthenticationAssertion
		): Promise<TokenPair> {
			return generateTokenPair();
		},
		async findAllPasskeysByUserId(): Promise<Passkey[]> {
			return passkeys;
		},
		async deletePasskey(id: string): Promise<string> {
			const passkeyIndex = passkeys.findIndex((passkey) => passkey.id === id);
			if (passkeyIndex === -1) {
				throw new Error('Passkey no encontrado');
			}
			passkeys.splice(passkeyIndex, 1);
			return id;
		}
	};
}

function generateValidPasskeys(): Passkey {
	return {
		id: uuidValueObject().generate(),
		deviceType: PasskeyDeviceTypesOptions.MULTI_DEVICE,
		backedUp: false,
		transports: ['internal', 'usb'],
		name: 'Demo User',
		createdAt: 0,
		lastUsedAt: 0
	};
}
